import { useEffect, useState } from "react";
import { Card, CardBody, CardFooter } from "../../../components/card/card";
import { dataTel3PostNewMain } from "../../../config/apiSPA";
import { useNavigate, useParams } from "react-router-dom";
import ModalInfo from "../../../components/modal/modalInfo";
import NewEventFormTel3FromOutstanding from "./formFromOutstanding";
const initialForm = {
  trId: null,
  category: null,
  remark: "",
  sasaranPelatihan: [],
};
const maxChar = 100;
function NewRecordTel3FromOutstanding() {
  const { id } = useParams();
  const [dataFill, setDataFill] = useState(initialForm);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [modalWarningNew, setModalWarningNew] = useState({ show: false, message: "-" });
  const [btnSpinner, setBtnSpinner] = useState(false);
  const navigate = useNavigate();
  const onChangeHandle = (e) => {
    const cleanedGoals = (e.sasaranPelatihan || []).filter((item) => item?.trim()).map((item) => item.trim());
    setDataFill({
      ...e,
      sasaranPelatihan: cleanedGoals,
    });
  };
  const handleClickSubmit = async (e) => {
    try {
      setBtnSpinner(true);
      const res = await dataTel3PostNewMain(e);
      navigate(`/training-evaluation-3/detail/${res.data.id}`);
    } catch (error) {
      setModalWarningNew({ show: true, message: error.message });
      setBtnSpinner(false);
    }
  };
  const charWarning = (texts) => {
    return texts.every((text) => text.length <= maxChar);
  };
  useEffect(() => {
    const disabled = !dataFill.trId || !dataFill.category || dataFill.sasaranPelatihan.length < 1 || !charWarning(dataFill.sasaranPelatihan);
    setBtnDisabled(disabled);
  }, [dataFill]);
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="row">
              <div className="col-xl-9">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#/">TEL 3</a>
                  </li>
                  <li className="breadcrumb-item active">New</li>
                </ul>

                <h1 className="page-header">New Training Evaluation Level 3 (Behaviour)</h1>

                <hr className="mb-4" />

                <div id="formControls" className="mb-5">
                  <p>
                    This evaluation is intended for the supervisor of the training participant to assess the consistency and application of competencies demonstrated after completing the training program. Three months after the training,
                    your feedback is essential to measure how effectively the participant has transferred the acquired knowledge and skills into their daily work.
                  </p>
                  <Card>
                    <CardBody className="pb-2">
                      <NewEventFormTel3FromOutstanding onChange={onChangeHandle} id={id} />
                    </CardBody>
                    <CardFooter>
                      {btnSpinner ? (
                        <button type="button" className="btn btn-lg btn-outline-theme" disabled>
                          <i className="spinner-border spinner-border-sm"></i>
                        </button>
                      ) : (
                        <button type="button" onClick={() => handleClickSubmit(dataFill)} className="btn btn-lg btn-outline-theme" disabled={btnDisabled}>
                          Submit
                        </button>
                      )}
                    </CardFooter>
                  </Card>
                </div>
              </div>
              <div className="col-xl-3"></div>
            </div>
          </div>
        </div>
      </div>
      <ModalInfo
        clicked={() => setModalWarningNew((a) => ({ ...a, show: false }))}
        onHide={() => setModalWarningNew((a) => ({ ...a, show: false }))}
        text={`Failed to create new TEL 3: ${modalWarningNew.message}`}
        title={"WARNING !!"}
        show={modalWarningNew.show}
        theme={"danger"}
      />
    </>
  );
}
export default NewRecordTel3FromOutstanding;
